import { z } from 'zod';
import { benefitStatusEnum } from '../enums';
import { countryCodeSchema, isoDateTimeSchema, paginationQuerySchema, slugSchema, urlSchema } from './common';

// Benefits are informational + CTA at MVP (decision D-B1): external link or
// promo code, optional validity window (D-B3), concept + country targeting (D-B4).
export const createBenefitSchema = z.object({
  title: z.string().trim().min(2).max(200),
  slug: slugSchema.optional(),
  summary: z.string().trim().max(300),
  body: z.string().max(100_000).nullable().optional(),
  partnerName: z.string().trim().min(1).max(120),
  partnerLogoUrl: urlSchema.nullable().optional(),
  ctaLabel: z.string().trim().max(60).nullable().optional(),
  ctaUrl: urlSchema.nullable().optional(),
  promoCode: z.string().trim().max(60).nullable().optional(),
  validFrom: isoDateTimeSchema.nullable().optional(),
  validUntil: isoDateTimeSchema.nullable().optional(),
  isFeatured: z.boolean().default(false),
  countryCodes: z.array(countryCodeSchema).optional(),
});
export type CreateBenefitPayload = z.infer<typeof createBenefitSchema>;

export const updateBenefitSchema = createBenefitSchema.partial();
export type UpdateBenefitPayload = z.infer<typeof updateBenefitSchema>;

export const benefitListQuerySchema = paginationQuerySchema.extend({
  status: benefitStatusEnum.optional(),
  search: z.string().trim().max(100).optional(),
});
export type BenefitListQuery = z.infer<typeof benefitListQuerySchema>;
